import { render, staticRenderFns } from "./product-list-by-item.vue?vue&type=template&id=3275b1c6&scoped=true&"
import script from "./product-list-by-item.vue?vue&type=script&lang=js&"
export * from "./product-list-by-item.vue?vue&type=script&lang=js&"
import style0 from "./product-list-by-item.vue?vue&type=style&index=0&id=3275b1c6&scoped=true&lang=css&"
import style1 from "./product-list-by-item.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3275b1c6",
  null
  
)

export default component.exports